import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";
import Configurator from "@/pages/Configurator";
import Reservation from "@/pages/Reservation";
import Tarifs from "@/pages/Tarifs";
import Admin from "@/pages/Admin";
import { PaiementSucces, PaiementAnnule } from "@/pages/PaymentResult";
import { MentionsLegales, PolitiqueConfidentialite } from "@/pages/Legal";

function App() {
  return (
    <BrowserRouter>
      <ReactLenis root options={{ lerp: 0.09, duration: 1.2 }}>
        <div className="App bg-[#272B2E] text-white">
          <div className="noise-overlay" />
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/configurateur" element={<Configurator />} />
            <Route path="/reservation" element={<Reservation />} />
            <Route path="/tarifs" element={<Tarifs />} />
            <Route path="/paiement/succes" element={<PaiementSucces />} />
            <Route path="/paiement/annule" element={<PaiementAnnule />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          </Routes>
          <Footer />
          <Toaster position="bottom-right" theme="dark" />
        </div>
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
